import { SettingsState } from 'reducers';

export const CLIENT_SETTINGS_KEY = 'clientSettings';

export type ClientSettings = Pick<SettingsState, 'player' | 'workspace'>;

// Saved values win, but only for keys the current version still has; throws on malformed JSON.
export function mergeClientSettings(current: ClientSettings, saved: string | null): ClientSettings | null {
    if (!saved) return null;
    const loaded = JSON.parse(saved);
    const merge = <T extends object>(section: T, from: unknown): T => {
        const result: Record<string, unknown> = { ...(section as Record<string, unknown>) };
        if (from && typeof from === 'object') {
            for (const key of Object.keys(result)) {
                if (key in from) result[key] = (from as Record<string, unknown>)[key];
            }
        }
        return result as T;
    };

    return {
        player: merge(current.player, loaded?.player),
        workspace: merge(current.workspace, loaded?.workspace),
    };
}
